import * as React from 'react';
import { mode } from '@/common/config';

const configurableRoutes = {
  ENABLE_ALL_VETS_PAGE: {
    path: '/discount',
    exact: false,
    component: React.lazy(() => import('../modules/all-vets-discount/pages/AllVetsDiscount.page')),
  },
};

export const baseRoutes = [
  {
    path: '/token',
    exact: true,
    component: React.lazy(() => import('../modules/auth/token/Token')),
  },
  {
    path: '/login',
    exact: true,
    component: React.lazy(() => import('../modules/auth/login/Login')),
  },
  {
    path: '/tour',
    exact: true,
    component: React.lazy(() => import('../modules/tour/Tour')),
  },
  {
    path: '/terms',
    exact: true,
    component: React.lazy(() => import('../modules/terms-and-conditions/TermsAndCondition')),
  },
  {
    path: '/privacy-policy',
    exact: true,
    component: React.lazy(() => import('../modules/privacy-policy/PrivacyPolicy')),
  },
  {
    path: '/onboarding',
    exact: true,
    component: React.lazy(() => import('../modules/onboarding/pages/landing/Landing')),
  },
  {
    path: '/onboarding/*',
    exact: false,
    component: React.lazy(() => import('../modules/onboarding/Onboarding.routes')),
  },
  {
    path: '/',
    exact: false,
    component: React.lazy(() => import('../Tabs')),
  },
];

export const maintenanceModeRoute = {
  path: '*',
  exact: false,
  component: React.lazy(() => import('../modules/maintenance/MaintenanceMode')),
};

export const activeRoutes = (configs) => {
  if (mode.maintenance) {
    return [maintenanceModeRoute];
  }

  const enabledPages = Object.keys(configurableRoutes)
    .filter((key) => configs?.[key])
    .map((key) => configurableRoutes[key]);

  return [...enabledPages, ...baseRoutes];
};
